import app from 'app';
import dlsIconNameMap from './dlsIconNameMap.js';

const FALLBACK_ICON = 'dls-icon-partner';

app.factory('chIconService', () => {

  /**
   * Get the corresponding dls-icon name of the ch-icon name
   *
   * @param  {string} chIconName - ch-icon name
   * @return {string} - dls-icon name
   */
  const getDlsIconName = function (chIconName) {
    const dlsIconName = dlsIconNameMap[chIconName];
    if (dlsIconName) {
      return dlsIconName;
    }
    return FALLBACK_ICON;
  };

  /**
   * Get the list of CH icon names
   * @return {array} - List of icon names that can be provided to ch-icon
   */
  const getIconNames = function () {
    return Object.keys(dlsIconNameMap);
  };

  return {
    getDlsIconName,
    getIconNames
  };

});



// WEBPACK FOOTER //
// ./services/chIconService.js